import { LOGS } from "./categories";
import { ConfigurableLogSink, LogEntry, LogLevel, SinkPolicy } from "./types";

const LEVEL_WEIGHT: Record<LogLevel | "off", number> = {
    info: 1,
    warn: 2,
    error: 3,
    off: 4,
};

export const DEFAULT_SINK_POLICY: SinkPolicy = {
    minLevel: "error",
    categories: [],
};

export const shouldHandle = (policy: SinkPolicy, entry: LogEntry): boolean => {
    if (policy.minLevel === "off") {
        return false;
    }

    if (LEVEL_WEIGHT[entry.level] >= LEVEL_WEIGHT[policy.minLevel]) {
        return true;
    }

    return entry.categories.some((category) =>
        policy.categories.includes(category),
    );
};

export const withCategory = (
    categories: readonly LOGS[],
    category: LOGS,
    enabled: boolean,
): LOGS[] =>
    enabled
        ? [...new Set([...categories, category])]
        : categories.filter((candidate) => candidate !== category);

export const createFilteredSink = (
    name: string,
    write: (entry: LogEntry) => void,
    initial: Partial<SinkPolicy> = {},
): ConfigurableLogSink => {
    let policy: SinkPolicy = { ...DEFAULT_SINK_POLICY, ...initial };

    return {
        name,
        getPolicy: () => ({ ...policy, categories: [...policy.categories] }),
        setPolicy: (patch) => {
            policy = { ...policy, ...patch };
        },
        handle: (entry) => {
            if (shouldHandle(policy, entry)) {
                write(entry);
            }
        },
    };
};
